import { Injector } from '@angular/core';
import { BehaviorSubject, Observable, of, combineLatest } from 'rxjs';
import { AthleteBiographyStore, IAthleteCategories, IAthleteBiography, AthleteEditorialBiographyStore, IAthleteEditorialBiography } from '../../common-page-components/stores/entities-store/athlete-biography-store';
import { FiltersAbstractService } from '../../common-page-components/classes/filters-abstract-service';
import { filter, mergeMap, distinctUntilChanged, map, tap, catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { AthleteCategoriesCombo, AthleteDisciplineStatisticsCombo } from '../../common-page-components/stores/filters-store/filters-store';
import { AthletePhotosStore } from 'src/app/common-page-components/stores/entities-store/athlete-photos-store';
import { RelatedAthletesStore } from '../../common-page-components/stores/entities-store/related-athletes-store';
import { Router, ActivatedRoute, ActivationEnd } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { flatten } from 'src/app/officials/components/bootstrap-officials/bootstrap-officials.component';
import { AthleteRecordsCategoriesCombo } from '../../common-page-components/stores/entities-store/athlete-records-store';
import { AthleteNewsStore } from 'src/app/common-page-components/stores/entities-store/athlete-news-store';
import { AthleteQuotesStore } from 'src/app/common-page-components/stores/entities-store/athlete-quotes.store';
import { AthleteWCupPageStore } from 'src/app/common-page-components/stores/entities-store/world-cup-athlete.store';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@angular/router";
import * as i3 from "@angular/platform-browser";
export class FiltersAthleteGeneralService extends FiltersAbstractService {
    constructor(http, injector, router, route, titleService) {
        super();
        this.http = http;
        this.injector = injector;
        this.router = router;
        this.route = route;
        this.titleService = titleService;
        /**
         * Routes to bind to and make a substitution in the panel. These are empty on first step and reassinged in function.
         *
         * @type {Array<IThirdNavCollapsibleElement>}
         * @memberof FiltersAthleteGeneralService
         */
        this.routes = [
            { name: "athlete.tab.biography", route: "biography" },
            { name: "athlete.tab.results", route: "results" },
            { name: "athlete.tab.statistics", route: "statistics" },
            { name: "athlete.tab.matches", route: "matches" },
            { name: "athlete.tab.world_records", route: 'records' },
            { name: "athlete.tab.world_cup", route: "world-cup" },
            { name: "athlete.tab.quotes", route: 'quotes' },
            { name: "Photos", route: 'photos' },
            { name: "athlete.tab.videos", route: `https://www.youtube.com/channel/UCb467UvO4jRgKxWX1oqtkzA/videos?query=name`, external: true },
        ];
        /**
         * A Hash map for cache the athletes into the application.
         *
         * @memberof FiltersAthleteGeneralService
         */
        this.cacheForAthletes = new Map();
        /**
         * A property for set and get the Id of athlete when navigation happens
         *
         * @type {BehaviorSubject<string>}
         * @memberof FiltersAthleteGeneralService
         */
        this.storedId = new BehaviorSubject(undefined);
        /**
         * The store of the athlete photos.
         *
         * @memberof FiltersAthleteGeneralService
         */
        this.athletePhotoStore = new AthletePhotosStore(this.http);
        /**
         * The store to get the wcup data of athlete.
         *
         * @memberof FiltersAthleteGeneralService
         */
        this.athleteWCupStore = new AthleteWCupPageStore(this.http, this.injector);
        /**
         * The quotes store for the athlete.
         *
         * @memberof FiltersAthleteGeneralService
         */
        this.athleteQuotesStore = new AthleteQuotesStore(this.http, this.injector, undefined);
        /**
         * Related athletes panel data.
         *
         * @type {Array<IAthlete>}
         * @memberof FiltersAthleteGeneralService
         */
        this.relatedAthletes = [];
        /**
         * Randomg image variable for avoid infinite cycle of changes.
         *
         * @type {string}
         * @memberof BootstrapAthleteComponent
         */
        this.randomgImg = new BehaviorSubject(undefined);
        /**
         * Athlete subject for detecth changes.
         *
         * @memberof FiltersAthleteGeneralService
         */
        this.athleteSubject = new BehaviorSubject(undefined);
    }
    cacheSubscription(previousParams) {
        const tmpParams = {
            id: previousParams ? previousParams.id : undefined, name: previousParams ?
                previousParams.name : "", urlSegments: {}, urlToRedirect: previousParams ? previousParams.redirectTo : undefined
        };
        let athleteRef;
        return this.router.events
            .pipe(filter(a => a instanceof ActivationEnd), tap((a) => Object.assign(tmpParams.urlSegments, a.snapshot["_urlSegment"])), map((a) => a.snapshot.params), filter(a => a.id != null), distinctUntilChanged((f, s) => {
            return f.id === s.id;
        }), tap(a => Object.assign(tmpParams, a)), filter(a => Object.keys(tmpParams).length > 0), tap(a => {
            this.routes = [
                { name: "athlete.tab.biography", route: "biography" },
                { name: "athlete.tab.results", route: "results" },
                { name: "athlete.tab.statistics", route: "statistics" },
                { name: "athlete.tab.matches", route: "matches" },
                { name: "athlete.tab.world_records", route: 'records' },
                { name: "athlete.tab.world_cup", route: "world-cup" },
                { name: "athlete.tab.quotes", route: 'quotes' },
                { name: "Photos", route: 'photos' },
                { name: "News", route: 'news' },
                { name: "athlete.tab.videos", route: `https://www.youtube.com/channel/UCb467UvO4jRgKxWX1oqtkzA/videos?query=name`, external: true }
            ];
        }), mergeMap(a => {
            // Notify components to the change of the id of the athlete.
            this.storedId.next(tmpParams.id.toString());
            // We have two options. If the athlete is cached in hash map, we return it and execute the method
            // for reassign all variables. If not, we need to call the api and set the cache..
            return Observable.if(() => this.cacheForAthletes.has(tmpParams.id.toString()), of(undefined).pipe(mergeMap(a => this.athleteIsCached(tmpParams))), this.athleteDoesNotItsCached(tmpParams, athleteRef));
        }), tap(athlete => {
            const url = this.router.createUrlTree([
                "/profile",
                tmpParams.id,
                this.getAthleteName(athlete)
                    .replace(/ /g, "-")
                    .toLowerCase(),
                tmpParams.urlToRedirect ? tmpParams.urlToRedirect : this.routes[0] ? this.routes[0].route.split('/')[0] : 'biography'
            ], { relativeTo: this.route, queryParamsHandling: 'merge' });
            const requestedRoute = this.route.snapshot['_routerState'].url.split('?')[0].split('/');
            const routeNotExistsInNav = this.routes.findIndex(value => value.route === requestedRoute[requestedRoute.length - 1]) === -1;
            // Set the id for commong use
            if (routeNotExistsInNav
                ||
                    athlete && tmpParams.name === ""
                ||
                    tmpParams.name !== this.getAthleteName(athlete).replace(/ /g, '-').toLowerCase()) {
                // If not name is set in the route, continue navigation and set propertly parameters
                // https://medium.com/agilix/change-the-route-without-reloading-in-angular-7a4aa82a8d3e
                this.router.navigate([`profile/${athlete.Id}/${this.getAthleteName(athlete).replace(/ /g, '-').toLowerCase()}/` + this.routes[0].route], { queryParamsHandling: 'merge' });
                //swindow.history.replaceState({}, "", url.toString());
            }
            /*
            *  Else the navigation as been performed properly, so in this way we show the component and avoid
            *  a not good flick in the view.
            */
            this.titleService.setTitle(this.getAthleteName(athlete) + " | " + "World Archery");
            return athlete;
        }));
    }
    /**
     * Method for return a observable if the athlete is cached.
     *
     * @param {*} tmpParams temp params of the router.
     * @returns
     * @memberof FiltersAthleteGeneralService
     */
    athleteIsCached(tmpParams) {
        const cache = this.cacheForAthletes.get(tmpParams.id.toString());
        this.relatedAthletes = cache.relatedAthletes;
        this.relatedAthletesStore = cache.relatedAthletesStore;
        this.athletePhotoStore = cache.athletePhotosStore;
        this.routes = cache.routes;
        this.randomgImg = cache.bannerImg;
        this.athleteDetailStore = cache.athleteDetailStore;
        this.athleteSubject = cache.athlete;
        this.news = cache.news;
        this.recordsCombo = cache.recordsCombo;
        this.athleteNewsStore = cache.athleteNewsStore;
        this.athleteEditorialBiographyStore = cache.athleteEditorialBiography;
        this.athleteStaticsticsDisciplineCombo = cache.athleteDisciplineStatsCombo;
        // Return the athlete for perform the change of the title.
        return of(this.athleteDetailStore.data[0]);
    }
    spliceRoute(routeName) {
        const index = this.routes.findIndex(value => value.name.includes(routeName));
        if (index > -1) {
            this.routes.splice(index, 1);
        }
        return index;
    }
    prepareRoutesForName() {
        this.routes = this.routes.map(route => {
            const replaced = route.route
                .replace("name", this.getAthleteName(this.athleteDetailStore.data[0])
                .toLocaleLowerCase()
                .replace(/ /g, "-"))
                .replace("Id", this.athleteDetailStore.data[0].Id.toString());
            route.route = replaced;
            return {
                name: route.name,
                route: replaced,
                external: route.external
            };
        });
    }
    mustSpliceBiography() {
        const arrayOfBiographyData = Array.from(this.athleteDetailStore.data[0].BioFields).filter(value => {
            return [2, 12, -1, -2, 46, 47, 31, 32, 25, 9, 21, 22, 24, 23].indexOf(value.BioId) > -1;
        });
        const mustSpliceBiographyPositionsOrData = arrayOfBiographyData.length === 0
            && this.getAthletePositions(this.athleteDetailStore.data).length === 0;
        const haveInsights = [
            this.athleteDetailStore.olympic_champion,
            this.athleteDetailStore.olympic_medallist,
            this.athleteDetailStore.paralympic_champion,
            this.athleteDetailStore.paralympic_medallist,
            this.athleteDetailStore.world_archery_champion,
            this.athleteDetailStore.olympian,
            this.athleteDetailStore.paralympic,
            this.athleteDetailStore.world_medallist,
            this.athleteDetailStore.olympic_record_holder,
            this.athleteDetailStore.paralympic_record_holder,
            this.athleteDetailStore.world_record_holder,
            this.athleteDetailStore.competition_best_compound,
            this.athleteDetailStore.competition_best_recurve,
            this.athleteDetailStore.match_wins,
            this.athleteDetailStore.world_cup_champion
        ].map((value) => value.length).reduce((f, s) => f + s, 0) > 0;
        const haveMedals = this.athleteDetailStore.data[0].Medals
            .filter(value => value.ComLevel === 3 && value.ComSubLevel === 13 ||
            value.ComLevel === 3 && value.ComSubLevel === 12 ||
            value.ComLevel === 2).length > 0;
        return mustSpliceBiographyPositionsOrData && !haveInsights && !haveMedals;
    }
    /**
     * One method to add the values of stats combo.
     * This method only checks if values are present and filter the values presented in the combo.
     *
     * @param {*} stats the stats Object.
     * @param {*} statsIndoor The indoor stats Object.
     * @memberof FiltersAthleteGeneralService
     */
    prepareStatisticsDisciplineCombo(stats, statsIndoor) {
        this.athleteStaticsticsDisciplineCombo = new AthleteDisciplineStatisticsCombo('Discipline', 'athlete-stats-discipline');
        const options = this.athleteStaticsticsDisciplineCombo['extraOptions'];
        if (!stats) {
            options.splice(0, 1);
        }
        if (!statsIndoor) {
            options.splice(1, 1);
        }
        this.athleteStaticsticsDisciplineCombo.setData(options.map(i => i.item), options[0]);
    }
    /**
     * A method for return a observable if the athlete is not cached.
     *
     * @param {*} tmpParams the router params.
     * @param {*} athleteRef The athlete reference.
     * @returns
     * @memberof FiltersAthleteGeneralService
     */
    athleteDoesNotItsCached(tmpParams, athleteRef) {
        this.relatedAthletesStore = new RelatedAthletesStore(this.http, this.injector);
        this.athleteNewsStore = new AthleteNewsStore(this.http);
        this.athleteDetailStore = new AthleteBiographyStore(this.http, this.injector, tmpParams.id);
        this.athleteQuotesStore = new AthleteQuotesStore(this.http, this.injector, tmpParams.id);
        this.athleteEditorialBiographyStore = new AthleteEditorialBiographyStore(this.http, this.injector, tmpParams.id);
        let comboRecordsStore;
        return this.athleteDetailStore.requestData({ Id: tmpParams.id, Detailed: 1 }, false).pipe(
        // We  should check if there's any athlete in biography response, if not we set it to null.
        tap(a => athleteRef = a.items.length > 0 ? a.items[0] : null), map(a => {
            if (athleteRef) {
                return a;
            }
            else {
                throw new Error(`athlete_error_loading`);
            }
        }), map(data => data.items[0].AthleteCategories), tap((data) => {
            const comboData = data
                .filter(item => item.IndividualTeam === 1)
                .map((value, i) => { return { item: value, position: i }; });
            this.athleteCategoriesCombo = new AthleteCategoriesCombo('Categories:', 'category-athlete', comboData, this.http, false);
            this.recordsCombo = new AthleteRecordsCategoriesCombo("Categories:", "", comboData, this.http, tmpParams.id.toString());
        }), mergeMap(a => {
            if (athleteRef && athleteRef.WorldRankings && athleteRef.WorldRankings.Current[0]) {
                this.relatedAthletesStore.athleteRanking = athleteRef.WorldRankings.Current[0].Rnk;
                this.relatedAthletesStore.athleteCountry = athleteRef.NOC;
                this.relatedAthletesStore.athleteId = athleteRef.Id.toString();
                this.relatedAthletesStore.athleteCategory = a.map(a => a.Cat);
                return this.relatedAthletesStore.requestData({}, false);
            }
            else {
                return of([]);
            }
        }), tap(next => {
            this.relatedAthletes = next;
            this.getPhotos().subscribe();
            this.getQuotes().subscribe();
            this.getWCupAthlete().subscribe();
            this.getEditorialBiography().pipe(catchError((err) => of([]))).subscribe();
            this.getAthletesNews().pipe(catchError((err) => of([]))).subscribe();
            if (this.filterRecords(this.athleteDetailStore.data[0].Records).length === 0) {
                this.spliceRoute('records');
            }
            if (this.athleteDetailStore.data[0].AthleteCategories.length === 0) {
                this.spliceRoute('results');
                this.spliceRoute('matches');
            }
            if (Object.keys(this.athleteDetailStore.data[0].Stats).length === 0 && Object.keys(this.athleteDetailStore.data[0].IndoorStats).length === 0) {
                this.spliceRoute('statistics');
            }
            else {
                this.prepareStatisticsDisciplineCombo(this.athleteDetailStore.data[0].Stats, this.athleteDetailStore.data[0].IndoorStats);
            }
            this.prepareRoutesForName();
        }), mergeMap(a => combineLatest(of(athleteRef))), map(([athlete]) => {
            if (this.athleteDetailStore.data[0].AthleteCategories.length === 0 && tmpParams.urlToRedirect == null) {
                Object.assign(tmpParams, { urlToRedirect: 'biography' });
            }
            return athlete;
        }), tap(a => {
            const header = a.HeaderImage && a.HeaderImage['URL'] ? a.HeaderImage['URL'] : this.selectRandomImage();
            this.randomgImg = new BehaviorSubject(header);
            this.athleteSubject = new BehaviorSubject(athleteRef);
            // Set the cache to the hash map.
            this.cacheForAthletes.set(tmpParams.id.toString(), {
                athleteQuotesStore: this.athleteQuotesStore,
                athleteDetailStore: this.athleteDetailStore,
                relatedAthletesStore: this.relatedAthletesStore,
                athletePhotosStore: this.athletePhotoStore,
                bannerImg: this.randomgImg,
                athleteCategoriesCombo: this.athleteCategoriesCombo,
                relatedAthletes: this.relatedAthletes,
                athlete: this.athleteSubject,
                recordsCombo: this.recordsCombo,
                routes: this.routes,
                news: this.news,
                athleteNewsStore: this.athleteNewsStore,
                athleteEditorialBiography: this.athleteEditorialBiographyStore,
                athleteDisciplineStatsCombo: this.athleteStaticsticsDisciplineCombo
            });
        }));
    }
    /**
     * Method for filter records only with level id equals to two and hide the route.
     *
     * @param {Array<any>} records The records array of athlete biography.
     * @returns
     * @memberof FiltersAthleteGeneralService
     */
    filterRecords(records) {
        return records.filter(value => value.RecordLevelId === 2);
    }
    /**
     *
     * @inheritdoc
     * @returns {void}
     * @memberof FiltersAthleteGeneralService
     */
    generateDefaultValues() {
        return;
    }
    /**
     *
     * @inheritdoc
     * @returns {Observable<any>}
     * @memberof FiltersAthleteGeneralService
     */
    getDataStreamWithFilters() {
        return;
    }
    /**
     * Function for filter the combo without team.
     *
     * @memberof FiltersAthleteGeneralService
     */
    filterCategoriesWithoutTeam(element) {
        return element.isTeam === false;
    }
    /**
     * Method to check if the athlete route for wcup must be set.
     *
     * @return {*}
     * @memberof FiltersAthleteGeneralService
     */
    getWCupAthlete() {
        return this.storedId.asObservable().pipe(filter(value => value != null), distinctUntilChanged((f, s) => f !== s), mergeMap(a => {
            return this.athleteWCupStore.requestData({ Id: a }, false);
        }), tap(wCup => {
            if (wCup.items.length === 0) {
                this.spliceRoute("world_cup_ranking");
            }
            else {
                this.prepareRoutesForName();
            }
        }));
    }
    /**
     * A method for get photos.
     *
     * @returns {Observable<IPhotos>}
     * @memberof FilterAthletePhotosServiceService
     */
    getPhotos() {
        return this.storedId.asObservable().pipe(filter(value => value != null), distinctUntilChanged((f, s) => f !== s), mergeMap(a => {
            this.athletePhotoStore.athlete_id = a;
            return this.athletePhotoStore.requestData({}, false);
        }), tap(photos => {
            if (photos.results.length === 0) {
                this.spliceRoute("photos");
            }
            else {
                this.prepareRoutesForName();
            }
        }));
    }
    getQuotes() {
        return this.athleteQuotesStore.requestData({}, false).pipe(tap(quotes => {
            console.log(quotes);
            if (quotes.length === 0) {
                this.spliceRoute("quotes");
            }
            else {
                this.prepareRoutesForName();
            }
        }));
    }
    /**
     * Method for get the editorial biography of an athlete.
     *
     * @returns
     * @memberof FiltersAthleteGeneralService
     */
    getEditorialBiography() {
        return this.storedId.asObservable().pipe(filter(value => value != null), distinctUntilChanged((f, s) => f !== s), mergeMap(a => {
            this.athleteEditorialBiographyStore.athleteId = a;
            return this.athleteEditorialBiographyStore.requestData({}, false);
        }), tap(editorial_biography => {
            const mustSplice = this.mustSpliceBiography();
            if (editorial_biography.length === 0 && mustSplice) {
                this.spliceRoute('biography');
            }
        }));
    }
    /**
     * Method for get the news of athlete.
     *
     * @returns {Observable<IAthleteNews>}
     * @memberof FiltersAthleteGeneralService
     */
    getAthletesNews() {
        return this.storedId.asObservable().pipe(filter(value => value != null), distinctUntilChanged((f, s) => f !== s), mergeMap(a => {
            this.athleteNewsStore.athlete_id = a;
            return this.athleteNewsStore.requestData({}, false);
        }), tap(news => {
            this.news = news['results'] ? news['results'] : [];
            if (this.news.length === 0) {
                this.spliceRoute('news');
            }
        }));
    }
    /**
     * A method for obtain the athlete name
     *
     * @returns
     * @memberof BootstrapAthleteComponent
     */
    getAthleteName(athlete) {
        // tslint:disable-next-line:max-line-length
        return athlete.WNameOrd === false
            ? athlete.GName + " " + athlete.FName
            : athlete.FName + " " + athlete.GName;
    }
    /**
     * A method for select a randomg image if not one is provided by api.
     *
     * @memberof BootstrapAthleteComponent
     */
    selectRandomImage() {
        const randomInt = this.getRandomInt(1, 7);
        return `../../../../modules/custom/wa_angular/app/assets/images/athlete-headers/D19_${randomInt.toString()}.jpg`;
    }
    /**
     * Get a random number between two numbers.
     *
     * @param {*} min
     * @param {*} max
     * @returns
     * @memberof FiltersAthleteGeneralService
     */
    getRandomArbitrary(min, max) {
        return Math.random() * (max - min) + min;
    }
    /**
     * Get randomg int into two numbers.
     *
     * @param {*} min
     * @param {*} max
     * @returns
     * @memberof FiltersAthleteGeneralService
     */
    getRandomInt(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
    /**
     * A method for check is athlete is in cache.
     *
     * @param {string} id
     * @returns
     * @memberof FiltersAthleteGeneralService
     */
    isAthletePresent(id) {
        return this.cacheForAthletes.has(id);
    }
    /**
     * Method for get the positions of the athlete.
     *
     * @param {Array<any>} data The athlete object from api as array.
     * @returns
     * @memberof FiltersAthleteGeneralService
     */
    getAthletePositions(data) {
        let positions = Object.keys(data[0].Positions)
            .map(key => {
            data[0].Positions[key].forEach(value => {
                value.type = key;
            });
            return data[0].Positions[key];
        })
            .map(association => association);
        positions = Array.from(flatten(positions)
            .reduce((a, b) => a.set(b, b), new Map()).values());
        return positions.filter(value => value.FunStart !== '');
    }
}
FiltersAthleteGeneralService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FiltersAthleteGeneralService_Factory() { return new FiltersAthleteGeneralService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i0.INJECTOR), i0.ɵɵinject(i2.Router), i0.ɵɵinject(i2.ActivatedRoute), i0.ɵɵinject(i3.Title)); }, token: FiltersAthleteGeneralService, providedIn: "root" });
